import { render, staticRenderFns } from "./ModalNewRecipe.vue?vue&type=template&id=624817b4"
import script from "./ModalNewRecipe.vue?vue&type=script&lang=js"
export * from "./ModalNewRecipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports